module.exports = __webpack_public_path__ + "img/app-store-badge.fa295bb6.png";